import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CategoryFilterTreeItem } from 'app/Model/Catalog/exportFilter/categoryFilterTreeItem';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { ExportFilterService } from 'app/Services/exportFilter.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';
import { DxTreeViewComponent } from 'devextreme-angular';
import { lastValueFrom } from 'rxjs';
import { OdooConnection } from '../../../Model/Catalog/OdooConnection';
import { OdooService } from '../../../Services/odoo.service';
import { UserManagementService } from '../../../Services/userManagment.service';

@Component({
    selector: 'odoo',
    templateUrl: 'catalogOdoo.component.html',
    styleUrls: [],
    standalone: false
})
export class CatalogOdooComponent implements OnInit {
  @ViewChild('brandTree') brandTree: DxTreeViewComponent;
  @ViewChild('newTree') newTree: DxTreeViewComponent;  

  newCategoriesHaveLoaded = false;

  _odooCategories: any = null;   
  _npCategories: CategoryFilterTreeItem[] = null;

  get odooCategories(): any {
    return this._odooCategories;
  }

  get npCategories(): any {
    return this._npCategories;
  }

  get odooNewProductsCategory() : string {
    return this.model?.newProductsCategory?.toString() ?? "";
  }

  set odooNewProductsCategory(value){
     this.model.newProductsCategory = +value;
  }

  get showNewProductCatLoading() {
    return !this.newCategoriesHaveLoaded;
  }

  constructor(
    public translate: TranslateService,
    public userManagement: UserManagementService,
    public odooService: OdooService,
    public systemService: SystemService,
    public catalogService: CatalogService,
    public loginService: LoginService,
    public exportFilterService: ExportFilterService, 
  ) {
    this.sendCatalog = this.sendCatalog.bind(this);
    this.testConnection = this.testConnection.bind(this);
    this.valueChanged = this.valueChanged.bind(this);
    this.getCategories = this.getCategories.bind(this);    
  } 

  
  async ngOnInit(): Promise<void> {
    await this.getCategories(false);
    this.refreshCategoryFilter();
  }
  
  valueChanged(e) {
    this.catalogService.catalogChanged(e);
  }

  async getCategories(sendMessage = true) {
    this.newCategoriesHaveLoaded = false;
    let result = await lastValueFrom(
      this.odooService.getCategories(this.model.baseUri, this.model.database, this.model.user, this.model.apiKey)
    ).catch(error=> {
      if (sendMessage) this.systemService.notifyWarning(error.error);
      this.newCategoriesHaveLoaded = true;
      return [];
    });
    if (sendMessage)
      this.systemService.notifyInfo(result.length.toString() + this.translate.instant(' Kategorien wurden gefunden'));
    this._odooCategories = result;
    this.newCategoriesHaveLoaded = true;
  }

  get model(): OdooConnection {
    if (!this.catalogService.catalog.odooConnection) {
      this.catalogService.catalog.odooConnection = new OdooConnection();
      this.catalogService.catalog.odooConnection.baseUri = '';
      this.catalogService.catalog.odooConnection.apiKey = '';
      this.catalogService.catalog.odooConnection.user = '';
      this.catalogService.catalog.odooConnection.database = '';
    }
    return this.catalogService.catalog.odooConnection;
  }

  async testConnection() {
    try {
      await lastValueFrom(
        this.odooService.testConnection(this.catalogService.catalog.id, this.catalogService.catalog.customerId)
      );
      this.systemService.notifyInfo('Erfolgreich angemeldet');
    } catch (error) {
      this.systemService.notifyWarning(error.error.detail);
    }
  }

  async sendCatalog() {
    try {
      await lastValueFrom(
        this.odooService.startExport(this.catalogService.catalog.id, this.catalogService.catalog.customerId)
      );
      this.systemService.notifyInfo('Export wurde erstellt');
    } catch (error) {
      this.systemService.notifyWarning(error.error);
    }
  }

  refreshCategoryFilter() {
    this.exportFilterService.getCategoryFilterTreeElements(this.catalogService.catalog.id, this.loginService.currentUser.customerId)
      .toPromise()
      .then((filter: CategoryFilterTreeItem[]) => {
        this._npCategories = filter;
      })
      .finally(() =>{});
  }

  brand_itemSelectionChanged(e) {
    this.model.brandCategory = e.itemData.id;
    this.catalogService.updateCatalog();
  }

  brand_syncTreeViewSelection() {
    if (!this.brandTree) return;

    if (!this.model.brandCategory) {
      this.brandTree.instance.unselectAll();
    } else {
      this.brandTree.instance.selectItem(this.model.brandCategory);
    }
  }

  new_onTreeViewOpened(e: any) {
    if (this.newCategoriesHaveLoaded)
      this.newTree.instance.scrollToItem(this.newCategoriesHaveLoaded);
  }

  new_itemSelectionChanged(e: any) {
    if (!e.itemData?.id) return;

    this.odooNewProductsCategory = e.itemData.id;
  }

  new_syncTreeViewSelection(e:any){
    this.catalogService.updateCatalog();
  }








  get showToolTips(): boolean {
    return this.loginService.showToolTips;
  }

  get showProToolTips(): boolean {
    return this.loginService.showProToolTips;
  }

  get showPlaceHolders() {
    return this.loginService.showPlaceHolders;
  }

  canView(name: string): boolean {
    return this.userManagement.canView(name);
  }
  readOnlyUser(name: string): boolean {
    return !this.userManagement.canEdit(name);
  }
}
